import { DEV_FEATURE_VARIABLE, PROD_FEATURE_VARIABLE } from "../../constants";

const getConfigVariable = (featureToggleVariables, production) => {
  if (!featureToggleVariables) {
    return null;
  }

  return production
    ? featureToggleVariables[PROD_FEATURE_VARIABLE]
    : featureToggleVariables[DEV_FEATURE_VARIABLE];
};

export default getConfigVariable;
